import React, { Fragment, useState } from "react";
import { useForm } from "react-hook-form";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";

const RegisterForm = () => {
    const {
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors, isValid },
    } = useForm({
        mode: "onChange", // Validates onChange
        defaultValues: {
            digitalPayment: "digitalPaymentYes", // set the default selected radio
            propertyOwn: "propertyYes",
        },
    });

    const [digitalPay, setDigitalPay] = useState(true);
    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const [showFormSubmit, setshowFormSubmit] = useState(null);
    const [errorFormSubmit, seterrorFormSubmit] = useState(0);

    const handleRadioChange = (event) => {
        setDigitalPay(event.target.id === "digitalPaymentYes");
    };

    const onReCAPTCHAChange = (token) => {
        setRecaptchaToken(token);
    };

    const onSubmit = async (formData) => {
        const data = {
            lead_create: 1,
            first_name: formData.name,
            merchant_name_c: formData.name,
            phone_mobile: formData.phone,
            primary_address_city: formData.city,
            email1: formData.email,
            business_vintage_years_c: formData.businessExperience,
            acspm_c: formData.monthlyCard,
            accept_online:
                formData.digitalPayment == "digitalPaymentYes" ? "Yes" : "No",
            own_property: formData.propertyOwn == "propertyYes" ? "Yes" : "No",
            average_monthly_sales: formData.avgMonthlySale,
            has_edc_machine_c: formData.digitalSales,
            industry_type_c: formData.businessIndustry,
        };

        await axios
            .post(process.env.REACT_APP_API_FORM_URL, data, {
                headers: {
                    "x-api-key": process.env.REACT_APP_AUTHORIZATION,
                    Accept: "application/json, text/plain, */*",
                    "Content-Type": "application/json;charset=utf-8",
                },
            })
            .then((response) => {
                console.log("Response  register form:", response);
                console.log("Response register form:", response?.data);
                if (response.data?.body?.Success) {
                    seterrorFormSubmit(1);
                    setshowFormSubmit(true);
                    resetFrom();
                    setTimeout(() => {
                        setshowFormSubmit(false);
                    }, 5000);
                } else if (response.data?.body?.lead_id) {
                    seterrorFormSubmit(2);
                    setshowFormSubmit(true);
                    resetFrom();
                    setTimeout(() => {
                        setshowFormSubmit(false);
                    }, 5000);
                } else {
                    seterrorFormSubmit(3);
                    setshowFormSubmit(true);
                    setTimeout(() => {
                        setshowFormSubmit(false);
                    }, 5000);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const resetFrom = () => {
        reset();
    };

    return (
        <Fragment>
            <form
                id="contactForm"
                className="row"
                onSubmit={handleSubmit(onSubmit)}
            >
                <div className="col-12 col-sm-6 mb-7">
                    <input
                        type="text"
                        className={`form-control ${
                            errors.name ? "is-invalid" : ""
                        }`}
                        placeholder="Your Full Name*"
                        {...register("name", {
                            required: "Name is required",
                            minLength: {
                                value: 3,
                                message:
                                    "Name must be at least 3 characters long",
                            },
                        })}
                    />
                    {errors.name && (
                        <p className="text-danger">{errors.name.message}</p>
                    )}
                </div>

                <div className="col-12 col-sm-6 mb-7">
                    <select
                        className={`form-control ${
                            errors.city ? "is-invalid" : ""
                        }`}
                        {...register("city", {
                            required: "City selection is required",
                        })}
                    >
                        <option value="">Select Your City</option>
                        <option value="ahmedabad">Ahmedabad</option>
                        <option value="ajmer">Ajmer</option>
                        <option value="aurangabad">Aurangabad</option>
                        <option value="bangalore">Bangalore</option>
                        <option value="baroda">Baroda</option>
                        <option value="Belagum">Belagum</option>
                        <option value="bhubaneshwar">Bhubaneswar</option>
                        <option value="chandigarh">Chandigarh</option>
                        <option value="chennai">Chennai</option>
                        <option value="coimbatore">Coimbatore</option>
                        <option value="delhi">Delhi</option>
                        <option value="Gulbarga">Gulbarga</option>
                        <option value="Gwalior">Gwalior</option>
                        <option value="hubbali">Hubali</option>
                        <option value="hyderabad">Hyderabad</option>
                        <option value="indore">Indore</option>
                        <option value="jaipur">Jaipur</option>
                        <option value="jalandhar">Jalandhar</option>
                        <option value="jamshedpur">Jamshedpur</option>
                        <option value="Jodhpur">Jodhpur</option>
                        <option value="Kolhapur">Kolhapur</option>
                        <option value="kolkata">Kolkata</option>
                        <option value="lucknow">Lucknow</option>
                        <option value="ludhiana">Ludhiana</option>
                        <option value="madurai">Madurai</option>
                        <option value="mangalore">Mangalore</option>
                        <option value="mumbai">Mumbai</option>
                        <option value="mysore">Mysore</option>
                        <option value="nagpur">Nagpur</option>
                        <option value="nashik">Nashik</option>
                        <option value="Panipat">Panipat</option>
                        <option value="puducherry">Puducherry</option>
                        <option value="pune">Pune</option>
                        <option value="rajkot">Rajkot</option>
                        <option value="ranchi">Ranchi</option>
                        <option value="Salem">Salem</option>
                        <option value="Sikar">Sikar</option>
                        <option value="surat">Surat</option>
                        <option value="Tirupati">Tirupati</option>
                        <option value="Tiruppur">Tiruppur</option>
                        <option value="Trichy">Trichy</option>
                        <option value="Trivallur">Trivallur</option>
                        <option value="Tumkuru">Tumkuru</option>
                        <option value="Udaipur">Udaipur</option>
                        <option value="vijaywada">Vijaywada</option>
                        <option value="vizag">Visakhapatnam</option>
                    </select>
                    {errors.city && (
                        <span className="text-danger">
                            {errors.city.message}
                        </span>
                    )}
                </div>

                <div className="col-12 col-sm-6 mb-7">
                    <input
                        type="text"
                        className={`form-control ${
                            errors.phone ? "is-invalid" : ""
                        }`}
                        placeholder="Your Phone Number*"
                        {...register("phone", {
                            required: "Phone number is required",
                            pattern: {
                                value: /^[0-9]{10}$/,
                                message: "Phone number must be 10 digits",
                            },
                        })}
                    />
                    {errors.phone && (
                        <span className="text-danger">
                            {errors.phone.message}
                        </span>
                    )}
                </div>

                <div className="col-12 col-sm-6 mb-7">
                    <input
                        type="email"
                        className={`form-control ${
                            errors.email ? "is-invalid" : ""
                        }`}
                        placeholder="Your Email*"
                        {...register("email", {
                            required: "Email is required",
                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                message: "Invalid email address",
                            },
                        })}
                    />
                    {errors.email && (
                        <span className="text-danger">
                            {errors.email.message}
                        </span>
                    )}
                </div>

                <div className="col-12 col-sm-6 mb-7">
                    <select
                        className={`form-control ${
                            errors.businessExperience ? "is-invalid" : ""
                        }`}
                        {...register("businessExperience", {
                            required: "This field is required",
                        })}
                    >
                        <option value="">Years in Business*</option>
                        <option value="Less than 2 years">
                            Less than 2 years
                        </option>
                        <option value="2-5 years">2-5 years</option>
                        <option value="5 years &amp; above">
                            5 years &amp; above
                        </option>
                    </select>
                    {errors.businessExperience && (
                        <span className="text-danger">
                            {errors.businessExperience.message}
                        </span>
                    )}
                </div>

                <div className="col-12 col-sm-6 mb-7">
                    <select
                        className={`form-control ${
                            errors.avgMonthlySale ? "is-invalid" : ""
                        }`}
                        {...register("avgMonthlySale", {
                            required: "This field is required",
                        })}
                    >
                        <option value="">Your Average Monthly Sale*</option>
                        <option value="Less than 1 lakh">
                            Less than 1 lakh
                        </option>
                        <option value="Between 1 to 3 lakhs">
                            Between 1 to 3 lakhs
                        </option>
                        <option value="Between 3 to 5 lakhs">
                            Between 3 to 5 lakhs
                        </option>
                        <option value="More than 5 lakhs">
                            More than 5 lakhs
                        </option>
                    </select>
                    {errors.avgMonthlySale && (
                        <span className="text-danger">
                            {errors.avgMonthlySale.message}
                        </span>
                    )}
                </div>

                <div className="col-12 col-sm-12 mb-7">
                    <select
                        className={`form-control ${
                            errors.businessIndustry ? "is-invalid" : ""
                        }`}
                        {...register("businessIndustry", {
                            required: "This field is required",
                        })}
                    >
                        <option value="">Your Business Industry*</option>
                        <option value="General_Store_Supermarket">
                            General Store / Supermarket
                        </option>
                        <option value="Doctor">
                            Doctor/Hospital/Clinic and Labs/Healthcare
                        </option>
                        {/* <option value="Hospitals">Hospitals</option> */}
                        <option value="Hardware_and_Electrical">
                            Hardware and Electrical
                        </option>
                        <option value="Contractor">Contractor</option>
                        <option value="FMCG">FMCG</option>
                        <option value="Packaging_Material">
                            Packaging Material
                        </option>
                        <option value="Plastics">Plastics</option>
                        <option value="Fuel_and_Lubricants">
                            Fuel and Lubricants
                        </option>
                        <option value="Pharmaceuticals">Pharmaceuticals</option>
                        {/* <option value="HealthCare">HealthCare</option> */}
                        <option value="IT_and_ITeS">IT and ITeS</option>
                        <option value="Facility_Management">
                            Facility Management
                        </option>
                        <option value="Skilled_or_Semi_Skilled_Labour_Supplier">
                            Skilled or Semi-Skilled Labour Supplier
                        </option>
                        <option value="grocery">Groceries</option>
                        <option value="petrol pump">Petrol Pump</option>
                        <option value="Pharmacy">Pharmacy</option>
                        {/* <option value="clinic">Clinic &amp; Lab</option> */}
                        <option value="Optician">Optician</option>
                        {/* <option value="cdit">CDIT</option> */}
                        {/* <option value="home appliances">Home Appliances</option> */}
                        <option value="Consumer_Durables">
                            Consumer Durables/Home Appliances/CDIT/Electronics
                        </option>
                        <option value="Optician">Apparel Store</option>
                        <option value="Optician">Salon and Spa</option>
                        <option value="Optician">Mobile Store</option>
                        <option value="Others">Others</option>
                    </select>
                    {errors.businessIndustry && (
                        <span className="text-danger">
                            {errors.businessIndustry.message}
                        </span>
                    )}
                </div>

                <div className="row col-12 col-sm-12 mb-7">
                    <p>
                        Do you own a property? (Residential, Commercial,
                        Industrial, Warehouse, Plot)
                    </p>
                    <div className="col-md-6">
                        <input
                            type="radio"
                            id="propertyYes"
                            value={"propertyYes"}
                            {...register("propertyOwn", {
                                required: "Please select an option",
                            })}
                            className="custom-control-input "
                            style={{
                                transform: "scale(1.4)",
                                accentColor: "green",
                            }}
                        />
                        <label htmlFor="propertyYes" className="ps-2">
                            Yes
                        </label>
                    </div>
                    <div className="col-md-6 ">
                        <input
                            type="radio"
                            id="propertyNo"
                            value={"propertyNo"}
                            {...register("propertyOwn", {
                                required: "Please select an option",
                            })}
                            className="custom-control-input"
                            style={{
                                transform: "scale(1.4)",
                                accentColor: "green",
                            }}
                        />
                        <label htmlFor="propertyNo" className="ps-2">
                            No
                        </label>
                    </div>
                    {errors.digitalPayment && (
                        <span className="text-danger">
                            {errors.digitalPayment.message}
                        </span>
                    )}
                </div>

                <div className="row col-12 col-sm-12 mb-7">
                    <p>
                        Do you accept digital payment (Credit
                        Card/UPI/IMPS/Wallets)?*
                    </p>
                    <div className="col-md-6">
                        <input
                            type="radio"
                            id="digitalPaymentYes"
                            value={"digitalPaymentYes"}
                            {...register("digitalPayment", {
                                required: "Please select an option",
                            })}
                            className="custom-control-input "
                            style={{
                                transform: "scale(1.4)",
                                accentColor: "green",
                            }}
                            onChange={handleRadioChange}
                        />
                        <label htmlFor="digitalPaymentYes" className="ps-2">
                            Yes
                        </label>
                    </div>
                    <div className="col-md-6 ">
                        <input
                            type="radio"
                            id="digitalPaymentNo"
                            value={"digitalPaymentNo"}
                            {...register("digitalPayment", {
                                required: "Please select an option",
                            })}
                            className="custom-control-input"
                            style={{
                                transform: "scale(1.4)",
                                accentColor: "green",
                            }}
                            onChange={handleRadioChange}
                        />
                        <label htmlFor="digitalPaymentNo" className="ps-2">
                            No
                        </label>
                    </div>
                    {errors.digitalPayment && (
                        <span className="text-danger">
                            {errors.digitalPayment.message}
                        </span>
                    )}
                </div>

                {digitalPay && (
                    <>
                        <div className="col-12 col-md-12 col-sm-6 mb-7">
                            <select
                                className={`form-control ${
                                    errors.monthlyCard ? "is-invalid" : ""
                                }`}
                                {...register("monthlyCard", {
                                    required: "This field is required",
                                })}
                            >
                                <option value="">
                                    Monthly Card & Digital Sales*
                                </option>
                                <option value="Less than one lakh">
                                    Less than one lakh
                                </option>
                                <option value="1-2 Lakhs">1-2 Lakhs</option>
                                <option value="More than 2 Lakhs">
                                    More than 2 Lakhs
                                </option>
                            </select>
                            {errors.monthlyCard && (
                                <span className="text-danger">
                                    {errors.monthlyCard.message}
                                </span>
                            )}
                        </div>

                        <div className="col-12 col-md-12 col-sm-6 mb-7">
                            <select
                                className={`form-control ${
                                    errors.digitalSales ? "is-invalid" : ""
                                }`}
                                {...register("digitalSales", {
                                    required: "This field is required",
                                })}
                            >
                                <option value="">
                                    Accepting Digital payments since*
                                </option>
                                <option value="Less than 6 months">
                                    Less than 6 months
                                </option>
                                <option value="6 months and more">
                                    6 months and more
                                </option>
                            </select>
                            {errors.digitalSales && (
                                <span className="text-danger">
                                    {errors.digitalSales.message}
                                </span>
                            )}
                        </div>
                    </>
                )}

                <div className="col-auto">
                    <div className="form-check mb-2">
                        <input
                            className={`form-check-input ${
                                errors.terms ? "is-invalid" : ""
                            }`}
                            type="checkbox"
                            id="autoSizingCheck"
                            {...register("terms", {
                                required:
                                    "You must agree to the terms and conditions",
                            })}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="autoSizingCheck"
                        >
                            I agree to NeoGrowth’ s Privacy Policy and T&C. I
                            hereby give my consent to NeoGrowth to call on above
                            mentioned number and receive my Credit Information
                            from any Credit Bureau for the purpose of loan
                            underwriting and account monitoring.
                        </label>
                        {errors.terms && (
                            <span className="text-danger">
                                {errors.terms.message}
                            </span>
                        )}
                    </div>
                </div>

                <div className="col-12 col-sm-12 mb-7">
                    <ReCAPTCHA
                        sitekey="6LfNVKwhAAAAAALvZZhsu-taEYh7NLaAIfkvUU7v"
                        onChange={onReCAPTCHAChange}
                    />
                </div>

                <div className="col-12 text-center">
                    <button
                        type="submit"
                        className={`btn btn-primary btn-hover-primary `}
                        disabled={!recaptchaToken}
                    >
                        Submit
                    </button>
                </div>
            </form>

            <div
                // className={`modal ${1 == 1 ? "show" : ""}`}
                className={`modal ${showFormSubmit ? "show" : ""}`}
                style={{
                    backdropFilter: "blur(2px)",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    opacity: "1 !important",
                }}
            >
                <div className="modal-dialog modal-dialog-centered modal-md ">
                    <div
                        className="modal-content radius-box"
                        style={{ boxShadow: "0px 5px 5px -1px rgb(22 22 22)" }}
                    >
                        {/* <div className="modal-header bg-primary text-white innr-radius-box">
                            <h5 className="modal-title">NeoGrowth</h5>
                            <button
                                type="button"
                                className="btn-close btn btn-primary"
                                aria-label="Close"
                                onClick={() =>
                                    setshowFormSubmit(!showFormSubmit)
                                }
                            ></button>
                        </div> */}
                        <div className="modal-body text-center">
                            {errorFormSubmit == 1 ? (
                                <p className="mt-4 text-center">
                                    <span className="b-color">
                                        Thank you for your application. <br />
                                        <br />
                                        We have received your details and our
                                        team will <br />
                                        connect with you shortly.
                                        <br />
                                    </span>
                                </p>
                            ) : errorFormSubmit == 2 ? (
                                <p className="mt-4 text-center">
                                    <span className="b-color">
                                        We have received your registration.
                                        <br />
                                        <br />
                                        Our team will connect with you shortly.
                                    </span>
                                </p>
                            ) : (
                                <p className="mt-4 text-center">
                                    <span className="b-color">
                                        Technical error occurred.
                                        <br />
                                        <br />
                                        Please try again after sometime.
                                    </span>
                                </p>
                            )}
                            <button
                                type="button"
                                className="btn btn-sm btn-primary btn-hover-primary mt-2"
                                aria-label=""
                                onClick={() =>
                                    setshowFormSubmit(!showFormSubmit)
                                }
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default RegisterForm;
